import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { db } from "../../../firebase";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { useAuth } from "../../../context/AuthContext";
import { MenuItem, Select, Button } from "@mui/material";

const Settings = () => {
  const { t, i18n } = useTranslation();
  const { currentUser } = useAuth();
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const fetchLang = async () => {
      if (!currentUser) return;
      const userDoc = await getDoc(doc(db, "users", currentUser.uid));
      const lang = userDoc.data()?.language || "en";
      setLanguage(lang);
      i18n.changeLanguage(lang);
    };
    fetchLang();
  }, [currentUser, i18n]);

  const handleChange = (e) => {
    setLanguage(e.target.value);
  };

  const handleSave = async () => {
    if (!currentUser) return;
    await updateDoc(doc(db, "users", currentUser.uid), { language });
    i18n.changeLanguage(language);
  };

  return (
    <>
      <h2>{t("settings")}</h2>
      <Select value={language} onChange={handleChange}>
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="pt">Português</MenuItem>
      </Select>
      <Button onClick={handleSave}>{t("save")}</Button>
    </>
  );
};

export default Settings;
